import { render, staticRenderFns } from "./ModifyPopup.vue?vue&type=template&id=122bbc30"
import script from "./ModifyPopup.vue?vue&type=script&lang=js"
export * from "./ModifyPopup.vue?vue&type=script&lang=js"
import style0 from "./ModifyPopup.vue?vue&type=style&index=0&id=122bbc30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports